export default {
    lastGDMUpdate: null,
    publishStatus: null,
    exportFinished: null,
    isImportInProgress: false,
    entitySelected: false,
    selectedEntity: { name: null, code: null },
    entityList: []
};
